export default "__VITE_ASSET__DWMe3KPL__"